<script lang="ts">
import Logo from '$lib/components/Logo.svelte'
</script>

<div class="logo">
  <a href="/" title="Home">
    <Logo width="12.5rem" />
  </a>
</div>

<style>
/* Logo SVG is white-on-dark by default; dark fill for light slides / exported light HTML */
:global(.study-presentation.light-theme) .logo :global(#logo .cls-1),
:global(body.study-light-export .logo #logo .cls-1) {
  fill: var(--slide-fg) !important;
}

.logo {
  position: fixed;
  top: 1.1rem;
  left: 1.6rem;
  z-index: 300;
}

@media (max-width: 1024px) {
  .logo {
    top: 0.85rem;
    left: 1.1rem;
  }
  :global(#logo) {
    width: 9.8rem;
  }
}

@media (max-width: 640px) {
  .logo {
    top: 0.7rem;
    left: 1rem;
  }
  :global(#logo) {
    width: 8rem;
  }
}
</style>
